<template>
  <div class="dialog-preview">
    <div class="body" v-if="form" ref="body">
      <div class="close" @click="$emit('close')"></div>
<!--      <el-button type="info" @click="captureTarget">AI解題</el-button>-->
      <div class="container">
        <!-- 要截图的指定区域 -->
        <div ref="targetElement" class="target-box">
          <ChoiceEcho ref="ChoiceEcho" v-if="form.type == 0" :form="form"></ChoiceEcho>
          <DetermineEcho ref="DetermineEcho" v-else-if="form.type == 1" :form="form"></DetermineEcho>
          <FillingBlanksEcho ref="FillingBlanksEcho" v-else-if="form.type == 2" :form="form"></FillingBlanksEcho>
          <SumEcho ref="SumEcho" v-else-if="form.type == 3 || form.type == 8" :form="form"></SumEcho>
          <HotspotEcho ref="HotspotEcho" v-else-if="form.type == 4" :form="form"></HotspotEcho>
          <TextDragEcho ref="TextDragEcho" v-else-if="form.type == 5" :form="form"></TextDragEcho>
          <LigatureEcho ref="LigatureEcho" v-else-if="form.type == 6" :form="form"></LigatureEcho>
          <ImgDragEcho ref="ImgDragEcho" v-else-if="form.type == 7" :form="form"></ImgDragEcho>
          <TextDragEcho2 ref="TextDragEcho2" v-else-if="form.type == 9" :form="form"></TextDragEcho2>
          <MatrimFill ref="MatrimFill" v-else-if="form.type == 10" :form="form"></MatrimFill>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ChoiceEcho from './components/choice/choice_echo.vue';
import DetermineEcho from './components/determine/determine_echo.vue';
import FillingBlanksEcho from './components/fillingBlanks/fillingBlanks_echo.vue';
import MatrimFill from './components/fillingBlanks/matrim_fill.vue';
import SumEcho from './components/sum/sum_echo.vue'
import ImgDragEcho from './components/imgDrag/imgDrag_echo.vue'
import TextDragEcho from './components/textDrag/textDrag_echo.vue'
import TextDragEcho2 from './components/textDrag/textDrag_echo_2.vue'
import LigatureEcho from './components/ligature/ligature_echo.vue'
import HotspotEcho from './components/hotspot/hotspot_echo.vue'
import html2canvas from 'html2canvas';
import {bigmodelChat} from "@/api/question";
export default {
  props: {
    form: {
      type: Object
    }
  },
  components: {
    ChoiceEcho,
    DetermineEcho,
    FillingBlanksEcho,
    MatrimFill,
    SumEcho,
    ImgDragEcho,
    TextDragEcho,
    TextDragEcho2,
    LigatureEcho,
    HotspotEcho,
  },
  data() {
    return {
      nowTime: new Date().toLocaleString(),
      previewUrl: '' // 预览图片的 URL
    }
  },

  mounted() {
    // 对于大多数现代浏览器
    // document.body.addEventListener('wheel', function(e) {
    //     e.preventDefault();
    // }, { passive: false });
  },
  methods: {
    /**
     * 核心截图函数
     * @param {HTMLElement} element 要截图的DOM元素
     */
    async captureScreenshot(element) {
      try {
        // 配置项（关键：解决跨域、高清截图）
        const canvas = await html2canvas(element, {
          useCORS: true, // 允许跨域图片
          allowTaint: false, // 不允许污染画布
          scale: window.devicePixelRatio, // 适配高清屏幕
          logging: false, // 关闭控制台日志
          scrollX: 0, // 避免滚动偏移
          scrollY: 0
        });

// 方法1：PNG格式调整压缩级别（0-1）
// 0 压缩最强（文件最小），1 质量最高（文件最大）
        const base64ImageUrl = canvas.toDataURL('image/png', 0.5);
        let listQuery = {
          lang:0,
          stream:true,
          imageUrl:base64ImageUrl
        }
        bigmodelChat(listQuery).then((response) => {

          if (!response || !response.data || !response.data.content) {
            console.warn("接口返回数据格式异常，缺少必要的 content 字段");
            this.rulesForm.explanation = null; // 给默认值，避免表单字段为 undefined
            return;
          }
          console.info(response.data)
          this.rulesForm.explanation=response.data.content
        })
      } catch (error) {
        console.error('截图失败：', error);
      }
    },

    // 截图指定区域（通过ref获取元素）
    captureTarget() {
      const target = this.$refs.targetElement;
      if (!target) {
        alert('未找到要截图的区域');
        return;
      }
      this.captureScreenshot(target);
    },

    // 截图整个页面
    captureWholePage() {
      this.captureScreenshot(document.body);
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-preview {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #9b9b9b;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  font-family: "TaipeiSansTCBeta";
  .body {
    height: 80%;
    width: 90%;
    background-color: #fff6ec;
    border-radius: 15px;
    padding: 25px;
    box-sizing: border-box;
    position: relative;
    .close {
      position: absolute;
      top: -60px;
      right: -60px;
      width: 60px;
      height: 60px;
      cursor: pointer;
      border-radius: 50%;
      background-image: url('../../../assets/images/close.png');
      background-size: 100% 100%;
    }

    .container {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: relative;
      font-family: 'TimesNewRoman', sans-serif;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss">

.dialog-preview {
  .block-style-success {
    &:before {
      content: '';
      border: 2px solid #007416 !important;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }

  .hotspot .block-style-success {
    &:before {
      content: '';
      border: 2px dashed #007416 !important;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }

  .determine-success-br {
    border: 2px solid #007416 !important;
    position: relative !important;

    &:before {
      content: '';
      position: absolute;
      bottom: -6px;
      right: -6px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-image: url('../../../assets/images/circle-success.png');
      background-size: 100% 100%;
    }
  }
}

</style>